Game.Utils.Layers = {

	layers: {},

	init: function() {

		// Generate layers.
		this.layers = {
			groupLevelBottom: game.add.group(),
			groupElements: game.add.group(),
			groupLevelTop: game.add.group(),
			groupHud: game.add.group(),
			groupModal: game.add.group(),
		};

		// fix hud to camera,
		// Hud includes game based interfaces. Buttons, scores etc
		// This can be covered by modal elements.
		this.layers.groupHud.fixedToCamera = true;

		// Fix modal elements to camera.
		this.layers.groupModal.fixedToCamera = true;

		// Return layers.
		return this.layers;

	},

};
